import {
  type DiagnoseMcpServerResponse,
  type DiagnosticStepSchema,
  DiagnosticOutcome,
  McpServerLookupFailure,
} from '@/api/user-portal-api-generated';
import { NOTE_REMEDIATIONS } from '../constants/mcp-tester-content';

// Neither says the server is wrong: the probe never reached a conclusion, so
// reporting "not usable" would be a verdict we did not earn.
const INCONCLUSIVE_FAILURES: readonly McpServerLookupFailure[] = [
  McpServerLookupFailure.RATE_LIMITED,
  McpServerLookupFailure.SERVER_ERROR,
];

export function isInconclusive(failure: DiagnoseMcpServerResponse['failure']) {
  return Boolean(failure && INCONCLUSIVE_FAILURES.includes(failure));
}

// A note this build has no copy for is dropped at render, so the row and the
// verdict both work from this list rather than the raw one.
export function supportedNotes(step: DiagnosticStepSchema) {
  return (step.notes ?? []).filter(note => NOTE_REMEDIATIONS[note]);
}

// A WARNED row reads "Worth fixing" whatever its note, so it always counts; a
// passing step counts only where a remediation will appear beneath it.
export function countWarnings(steps: DiagnosticStepSchema[]): number {
  return steps.filter(
    step =>
      step.outcome === DiagnosticOutcome.WARNED ||
      supportedNotes(step).length > 0
  ).length;
}

export function failingStep(
  steps: DiagnosticStepSchema[]
): DiagnosticStepSchema | undefined {
  return steps.find(step => step.outcome === DiagnosticOutcome.FAILED);
}
